<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Toolbox-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Personal development ' + (screen.gs ? `${screen.gs.cycle.getDateRange()} for ${screen.gs.employee.name}` : '')"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Toolbox.GoalSettingView"
							>
								<div
									class="layout-block vertical"
									[style.align-items]="'inherit'"
									[style.gap]="'1em'"
								>
									<ng-container *ngIf="screen.gs"
										><Toolbox-GoalSettingViewInclude
											[$formDirective]="$formDirective"
											[$disabled]="$disabled"
											[$ignoreValidations]="$ignoreValidations"
											[gs]="screen.gs"
											[viewMode]="screen.viewMode"
										>
										</Toolbox-GoalSettingViewInclude
									></ng-container>
								</div>
							</div>
						</ng-container>
					</ng-template>
				</Toolbox-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
